type OrganizationLogoMarkProps = {
    name?: string;
    logo?: string;
    size?: number;
    className?: string;
};

export const OrganizationLogoMark = ({
    name,
    logo,
    size = 20,
    className = "",
}: OrganizationLogoMarkProps) => {
    const classes = ["nav-org-logo", className].filter(Boolean).join(" ");

    if (logo) {
        return (
            <img
                src={logo}
                alt={name ? `${name} logo` : "Organization logo"}
                className={classes}
                width={size}
                height={size}
            />
        );
    }

    const initial = name?.charAt(0)?.toUpperCase() || "?";

    return (
        <span
            className={`${classes} nav-org-logo--fallback`}
            style={{ width: size, height: size, fontSize: Math.max(10, size * 0.45) }}
            aria-hidden={!name}
        >
            {initial}
        </span>
    );
};
